module.exports = __webpack_public_path__ + "img/BG-1.a1b2e20.png";